import { render } from "./invoicestab.vue?vue&type=template&id=763515f2&scoped=true"
import script from "./invoicestab.vue?vue&type=script&lang=js"
export * from "./invoicestab.vue?vue&type=script&lang=js"

import "./invoicestab.vue?vue&type=style&index=0&id=763515f2&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763515f2"]])

export default __exports__